class constants {
    static permissions = {
        admin: 'ADMIN',
        moderator: 'MODERATOR',
        campaignStudioAccess: 'CAMPAIGN_STUDIO_ACCESS',
        createEtchAsset: 'CREATE_ETCH_ASSET'
    }
}

export default constants
